export default {
  // 登录页面路由地址，所有需要跳转到登录页面的业务都使用该配置
  LOGIN_PAGE: '/login',
  // 工程首页路由地址
  HOME_PAGE: '/security/home',
  // 页面无法找到的路由地址（当用户输入的地址不存在跳转至当前页面）
  PAGE_NOT_FOUND: '/pagenotfound',
  // 许可证上传页面（当证书失效或过期跳转到该页面）
  LICENCE: '/licence',
  // 系统使用的字体图标主样式
  fontFamily: 'iconfont1',
  // AES方式加密使用的秘钥，与平台约定使用的秘钥
  AES_KEY: '!Allcam@1234567#',
  // AES方式加密使用的秘钥偏移量
  AES_IV: 'brCMzN&rU3#81@Sm',
  // SHA方式加密使用的秘钥，与平台约定使用的秘钥
  SHA_KEY: '0123456789ABCDEF',
  // 生成UUID使用的hexDigits字符串
  UUID_KEY: '0123456789abcdef',
  // 系统默认分页对象，所有列表页面都引入基础分页对象信息，每页展示10条数据
  pageInfo: {
    pageNo: 1,
    pageSize: 10
  },
  // 列表数据获取时，每页对象的配置项
  pageSizes: [10, 30, 50, 100]
}